import type { ReactNode } from "react";
import TopNav from "@/components/layout/TopNav";
import Footer from "@/components/layout/Footer";

export default function PageLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <TopNav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}